if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        var config = ""

        const formData = new FormData(this.form);   

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          //Anarc Frost Blaze 
          if(formData.get("id") == 48934122914029 ){
            this.addBuyNowAnarcWithStraps(48934122914029, 47339908301037);
            return;
          }

          // Anarc Dark Brilliance
          if(formData.get("id") == 48934122881261){
            this.addBuyNowAnarcWithStraps(48934122881261, 47339908038893);
            return;
          }

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        // if (formData.get("id") != 46994527486189 && formData.get("id") != 46994499436781 && formData.get("id") != 46994527518957) {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

        // } else {
        //   const items = [
        //     {
        //       id: formData.get("id"),
        //       quantity: 1,
        //     },
        //     {
        //       id: "47362767585517",
        //       quantity: 1,
        //     }
        //   ]
        //   config = {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //       "Accept": "application/json",
        //     },
        //     body: JSON.stringify({
        //       items: items,
        //       sections: this.cart.getSectionsToRender().map((section) => section.id),
        //     })
        //   }
        // }
        
        if ( document.body.id === 'build-your-skin' || document.body.id === 'build-your-laptop-skin' ) {
          const select_custom_model = document.querySelector('#select_custom_model')
          if(select_custom_model && select_custom_model.value == '-1'){
            const this__ = this
            setTimeout(function(){
              this__.submitButton.classList.remove('loading');
              if (this__.cart && this__.cart.classList.contains('is-empty')) this__.cart.classList.remove('is-empty');
              if (!this__.error) this__.submitButton.removeAttribute('aria-disabled');
              this__.querySelector('.loading__spinner').classList.add('hidden');
            },1000)

            select_custom_model.scrollIntoView({
              behavior: 'smooth',
              block: 'center' 
            });
  
            this.handleErrorMessage('Please select model name')
            return;
          }
        }
        
        fetch(`${routes.cart_add_url}${formData.get("id") != 46994527486189 && formData.get("id") != 46994499436781 && formData.get("id") != 46994527518957 ? "" : ".js"}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            const getCart = await fetch('/cart.js');
            const cartData = await getCart.json();
            addGunmetal_FrostBlaze(cartData);
            // addSkin_Screenguard(cartData);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
        if(sessionStorage.getItem("expired_timer")){
          if(document.querySelector('.free_strap_birthday_sale_wapper')) document.querySelector('.free_strap_birthday_sale_wapper').classList.remove('hidden');
        }
        // initOfferTimer();
        // window.anarc_timer_pdp();
        // const hasSkinProduct = document.querySelector('#progress_skin');
        // if(hasSkinProduct){
        //   fetch('/cart.js')
        //   .then(resp => resp.json())
        //   .then(result => {
        //     const hasFreeSkin = result.items.some(item => item.id === 48603882848493);
        //     if(result.item_count >= 2 && !hasFreeSkin){
        //       mobileSkinCheck(48603882848493, 1);
        //     }
        //   })
        // }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            setTimeout(function(){
              document.querySelector('.gokwik-checkout button').removeAttribute('disabled');
              document.querySelector('.gokwik-checkout button').classList.remove('disabled');
            }, 2500)
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        const sticky_atc_initial_warning_hide = this.querySelector('.container__sticky_atc .product-form__error-message-wrapper');
        const sticky_atc_bar = document.querySelector('.anarc-new-pdp .product_form_error_message_wrapper');
        if(sticky_atc_initial_warning_hide) sticky_atc_initial_warning_hide.classList.add('hidden');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if(sticky_atc_bar) sticky_atc_bar.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          if(sticky_atc_bar) sticky_atc_bar.querySelector('.product_form_error_message').textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, variant = 0) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
           // this.submitButtonText.textContent = variant === 46994527518957 ? "Sold Out" : 
           // (variant === 46994499436781 || variant === 46994527486189 ? "Add to cart" : window.variantStrings.addToCart);
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      addBuyNowAnarcWithStraps(formId, strapid){
        document.body.classList.add('block_checkout_btn');
        fetch('/cart/add.js', {
          method: 'POST',
          headers:{
            "Content-Type":"application/json"
          },
          body:JSON.stringify({
            items:[{
              id: formId,
              quantity: 1
            },
            {
              id: strapid,
              quantity: 1
            }
          ],
            sections: this.cart.getSectionsToRender().map((section) => section.id)
          })
        })
        .then(resp => resp.json())
        .then(result => {
          this.cart.renderContents(result);
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        })
        .catch(error => {
          console.error('Failed to add gunmetal or chrome silver strap --> ', error);
        })
        .finally(() => {
          document.body.classList.remove('block_checkout_btn');
        })
      }
    }
  );
}

// function mobileSkinCheck(id, quantity){
//   fetch('/cart/update.js',{
//     method: 'POST',
//     headers:{
//       "Content-Type":"application/json"
//     },
//     body: JSON.stringify({
//       updates:{
//         [id]: quantity
//       },
//       sections: ['cart-drawer', 'cart-icon-bubble']
//     })
//   })
//   .then(resp => resp.json())
//   .then(result => {
//     const oldDrawer = document.querySelector('cart-drawer');
//     const oldIcon = document.querySelector('#cart-icon-bubble');
//     const newDrawer = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
//     const newIcon = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
//     oldDrawer.innerHTML = newDrawer.innerHTML;
//     oldIcon.innerHTML = newIcon.innerHTML;
//     initOfferTimer();
//   })
// }

// Add Straps with anarc varaint accordingly start
function addStrapWithAnarc(updates = {}){
  fetch('/cart/update.js',{
    method: 'POST',
    headers:{
      "Content-Type":"application/json"
    },
    body: JSON.stringify({
      updates,
      sections: ['cart-drawer', 'cart-icon-bubble']
    })
  })
  .then(resp => resp.json())
  .then(result => {
    const oldDrawer = document.querySelector('cart-drawer');
    const oldIcon = document.querySelector('#cart-icon-bubble');
    const newDrawer = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
    const newIcon = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    oldDrawer.innerHTML = newDrawer.innerHTML;
    oldIcon.innerHTML = newIcon.innerHTML;
  })
  .catch(error => {
    console.error('Failed to add gunmetal or chrome silver strap --> ', error);
  })
  .finally(() => {
    document.body.classList.remove('block_checkout_btn');
  })
}
// Add Straps with anarc varaint accordingly end

function addGunmetal_FrostBlaze(result){
  // Add Straps with anarc varaint accordingly start
    if( window.location.pathname == '/products/anarc-frost-blaze-with-chrome-silver' || window.location.pathname == '/products/anarc-dark-brilliance-with-gunmetal-black' ){
    // document.body.classList.add('block_checkout_btn');
    const has_anarc_dark_brilliance = result.items.some(item => item.id === 48934122881261) || false;
    const has_anarc_frost_blaze = result.items.some(item => item.id === 48934122914029) || false;
    const has_chrome_silver_straps = result.items.some(item => item.id === 47339908301037) || false;
    const has_gunmetal_straps = result.items.some(item => item.id === 47339908038893) || false;
      if(has_anarc_dark_brilliance && !has_gunmetal_straps){
        addStrapWithAnarc({47339908038893: 1})
      }else if(has_anarc_frost_blaze && !has_chrome_silver_straps){
        addStrapWithAnarc({47339908301037: 1})
      }
    }
  // Add Straps with anarc varaint accordingly end
}

// function addSkin_Screenguard(result){
//   if(!document.body.classList.contains('anarc-new-pdp')) return;
//     console.log("result", result)
//   const hasAnarcWatch = result.items.some(item => item.id === 46994499436781 || item.id === 46994527486189 || item.id === 46994527518957);
//   const anarcQuantity = result.items.find(item => item.id === 46994499436781 || item.id === 46994527486189 || item.id === 46994527518957).quantity || 0;
//   const hasSkin  = result.items.some(item => item.id === 48465802985709);
//   const hasGuard = result.items.some(item => item.id === 48694738878701);

//   if(hasAnarcWatch && anarcQuantity > 0 && anarcQuantity < 2 && (!hasSkin)){
//     addStrapWithAnarc({48465802985709: 1})
//   }
// }
